export type NightlyProductClass = 'PRBC' | 'FFP' | 'Whole' | 'Accessory';
export type NightlyProductBloodType = 'Positive' | 'Negative';

export interface INightlyCountSettingsProduct {
  id: string;
  productTitle: string;
  woocommerceProductId: number;
  productClass: NightlyProductClass;
  productBloodType?: NightlyProductBloodType | null;
}

export interface INightlyCountSettingsNotificationBucket {
  email?: { userIds: string[] };
  text?: { userIds: string[] };
  teams?: { userIds: string[] };
  template?: string;
}

export interface INightlyCountSettingsJson {
  products?: INightlyCountSettingsProduct[];
  officeUsers?: Record<string, string[]>;
  notifications?: Record<string, INightlyCountSettingsNotificationBucket>;
}

export const NIGHTLY_COUNTS_SETTINGS_TAB = 'nightly-counts';
export const NIGHTLY_COUNTS_NOTIFICATIONS_ALL_KEY = 'ALL';

export const PRODUCT_CLASSES_WITH_BLOOD_TYPE: NightlyProductClass[] = [
  'PRBC',
  'Whole',
];
